import { LazyLoadImage as m } from "react-lazy-load-image-component";
import a, { css as t } from "styled-components";
const f = a(m).withConfig({
  displayName: "Image",
  componentId: "sc-18f0k4f-0"
})(["vertical-align:middle;", ""], ({
  width: o = "auto",
  height: e = "auto"
}) => t(["height:", ";width:", ";"], typeof e == "number" ? `${e}px` : e, typeof o == "number" ? `${o}px` : o));
export {
  f as Image
};
//# sourceMappingURL=style.es.js.map
